import { AppUserData, AppUserRole } from '@/types/AppUser';

export enum PermissionScope {
    Global = 0,
    User = 1,
    Project = 2
}

export default class Authorization {
    public static checkAccessRights(appUser: AppUserData | null, operation: string, projectId?: string, scope: PermissionScope = PermissionScope.Global): boolean {

        let authorized = false;

        if (!appUser) {
            return authorized;
        }

        if (appUser.isAdministrator) {
            return true;
        }

        if (scope == PermissionScope.Global || scope == PermissionScope.User) {
            authorized = Authorization.findOperationInRoles(appUser.roles, operation);

            if (authorized) {
                return authorized;
            }
        }

        if (scope == PermissionScope.Global || scope == PermissionScope.Project) {
            if (projectId) {
                const index = appUser.projects.findIndex(p => p.id == projectId);
                if (index >= 0) {
                    const project = appUser.projects[index];
                    if (!project) {
                        return false;
                    }
                    authorized = Authorization.findOperationInRoles(project.roles, operation);
                }
            }
            else {
                for (let i = 0; i < appUser.projects.length; i++) {
                    authorized = Authorization.findOperationInRoles(appUser.projects[i].roles, operation);
                    if (authorized) {
                        break;
                    }
                }
            }
        }

        return authorized;
    }

    private static findOperationInRoles(roles: AppUserRole[], operation: string) {
        if (!roles) return false;

        for (const r of roles) {
            const index = r.operations.findIndex(o => o == operation);
            if (index >= 0) return true;
        }

        return false;
    }

    public static operations = {
        editMyPerformedWork: 'EditMyPerformedWork',
        editPerformedWorkForAllowedProjects: 'EditPerformedWorkForAllowedProjects',
        editProject: 'EditProject',
        editTask: 'EditTask',
        listAllUsersForAllowedProjects: 'ListAllUsersForAllowedProjects',
        listPerformedWorkForAllowedProjects: 'ListPerformedWorkForAllowedProjects',
        viewAllProjectTasks: 'ViewAllProjectTasks'
    }
}



